<app-page-header [header]="this.titel" [breadcrumbs]="[
    {label: 'Home',                        url: '/'},
    {label: 'Sitemap',  url: 'sitemap'}
]"></app-page-header>

<div class="block faq">
    <div class="container">



        <div class="row">
            <!-- <div class="col-12 col-lg-3 d-flex">
                <div class="account-nav flex-grow-1">
                    <h4 class="account-nav__title">Onderwerpen</h4>
                    <ul>
                        <li class="account-nav__item ng-star-inserted"
                            [ngClass]="{'account-nav__item--active': this.categorieseourl === ''}"><a href=" /faq">Top
                                10</a>
                        </li>
                        <li class="account-nav__item ng-star-inserted"
                            [ngClass]="{'account-nav__item--active': this.categorieseourl === 'algemeen'}"><a
                                href="/faq/onderwerp/algemeen">Algemeen</a></li>
                        <li class="account-nav__item ng-star-inserted"
                            [ngClass]="{'account-nav__item--active': this.categorieseourl === 'inmeten'}"><a
                                href="/faq/onderwerp/inmeten">Inmeten</a></li>
                        <li class="account-nav__item ng-star-inserted"
                            [ngClass]="{'account-nav__item--active': this.categorieseourl === 'bestellen-levering'}"><a
                                href="/faq/onderwerp/bestellen-levering">Bestellen en levering</a></li>
                        <li class="account-nav__item ng-star-inserted"
                            [ngClass]="{'account-nav__item--active': this.categorieseourl === 'prijzen-aanbiedingen'}">
                            <a href="/faq/onderwerp/prijzen-aanbiedingen">Prijzen en aanbiedingen</a>
                        </li>
                        <li class="account-nav__item ng-star-inserted"
                            [ngClass]="{'account-nav__item--active': this.categorieseourl === 'ondervloeren'}"><a
                                href="/faq/onderwerp/ondervloeren">Ondervloeren</a></li>


                    </ul>
                </div>
            </div> -->

            <div class="card mb-0">

                <div class="card-body contact-us">
                    <div class="row">

                        <div *ngIf="this.slug == ''">

                            <h2>Informatie</h2>

                            <ul>
                                <li><a routerLink="/sitemap/algemeen">Algemeen</a></li>
                                <li><a routerLink="/sitemap/faq">Veelgestelde vragen</a></li>
                            </ul>


                            <h2>Catalogus</h2>
                            <ul>
                                <li><a routerLink="/sitemap/merken">Merken</a></li>
                                <li><a routerLink="/sitemap/series">Series</a></li>
                            </ul>


                            <h2>Productinformatie</h2>
                            <ul>
                                <li><a routerLink="/sitemap/1">Artikel 1 t/m 100</a></li>
                                <li><a routerLink="/sitemap/2">Artikel 101 t/m 200</a></li>
                                <li><a routerLink="/sitemap/3">Artikel 201 t/m 300</a></li>
                                <li><a routerLink="/sitemap/4">Artikel 301 t/m 400</a></li>
                                <li><a routerLink="/sitemap/5">Artikel 401 t/m 500</a></li>
                                <li><a routerLink="/sitemap/6">Artikel 501 t/m 600</a></li>
                                <li><a routerLink="/sitemap/7">Artikel 601 t/m 700</a></li>
                                <li><a routerLink="/sitemap/8">Artikel 701 t/m 800</a></li>
                                <li><a routerLink="/sitemap/9">Artikel 801 t/m 900</a></li>
                                <li><a routerLink="/sitemap/10">Artikel 901 t/m 1000</a></li>
                                <li><a routerLink="/sitemap/11">Artikel 1001 t/m 1100</a></li>
                                <li><a routerLink="/sitemap/12">Artikel 1101 t/m laatste artikel</a></li>
                            </ul>



                        </div>
                        <div *ngIf="this.slug != ''">
                            <div class="typography" *ngFor="let row of rows; index as i">

                                <a href="{{row.url}}">{{row.name}}</a>
                                <!-- <div *ngIf="!row.url" [innerHTML]="row.full" (click)="getRoute($event)"></div> -->
                                <!-- <div *ngIf="!row.url"><br><a routerLink="/faq/onderwerp/{{this.categorieseourl}}">
                                            <img src="/assets/images/global/arrow-blue.svg"
                                                style="width: 10px; float: left; margin-top: 5px; margin-right: 10px; transform: rotate(180deg);">
                                            Terug naar overzicht</a></div>

                                    <div class="row" *ngIf="row.url" style="padding-bottom: 10px; border-bottom: 2px solid #f0f0f0;">
                                        <div class="col-1" style="min-width: 35px;">
                                            <img (click)="row.isCollapsed = !row.isCollapsed" *ngIf="row.isCollapsed"
                                                src="/assets/images/global/arrow-blue.svg"
                                                style="width: 10px; transform: rotate(90deg); float: left; margin-top: 10px; margin-right: 10px;">
                                            <img (click)="row.isCollapsed = !row.isCollapsed" *ngIf="!row.isCollapsed"
                                                src="/assets/images/global/arrow-blue.svg"
                                                style="width: 10px; transform: rotate(-90deg); float: left; margin-top: 10px; margin-right: 10px;">
                                        </div>
                                        <div class="col">
                                            <span (click)="row.isCollapsed = !row.isCollapsed"
                                                style="float: left; margin-top: 5px; font-weight: bold; ">{{row.title}}</span>
                                            <p [collapse]="row.isCollapsed" [isAnimated]="true" style="float: left;">
                                                <span [innerHTML]="row.intro"></span>
                                                <br><br>

                                                <a routerLink="/faq/{{row.url}}">
                                                    <img src="/assets/images/global/arrow-blue.svg"
                                                        style="width: 10px; float: left; margin-top: 5px; margin-right: 10px;">
                                                    Lees verder</a>
                                            </p>

                                        </div>
                                    </div> -->
                            </div>
                            <br>
                            <a routerLink="/sitemap">Naar sitemap overzicht</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
